import React from "react"
import SaleStage from "../components/SaleStage"

class Step9SS extends React.Component {
    render() {
        const { client, updateClient } = this.props;
        const { collateralDocs={} } = (client && client.stages_of_sale) || {};

        const {
            dateLoanTakeout,
            originalTitleUnderBuyersName,
            originalAnnotatedTitleUnderRrc,
            originalAnnotatedTitleUnderBuyersName,
            certifyTrueCopyOfTaxDeclarationForLandAndBuilding,
            certifyTrueCopyOfTaxClearance,
            receiptOfUpdatedAmelyar,
            receivingCopyOfCollateralDocuments,
            isCompleted,
            completionDate,
            others=[]
        } = collateralDocs;

        const step10Fields = [
            { key: 'dateLoanTakeout', type: 'date', label: 'Date Loan Takeout', value: dateLoanTakeout},
            { key: 'originalTitleUnderBuyersName', type: 'file', label: "Original Title Under Buyer's Name", value: originalTitleUnderBuyersName},
            { key: 'originalAnnotatedTitleUnderRrc', type: 'file', label: 'Original Annotated Title Under RRC', value: originalAnnotatedTitleUnderRrc},
            { key: 'originalAnnotatedTitleUnderBuyersName', type: 'file', label: "Original Annotated Title Under Buyer's Name", value: originalAnnotatedTitleUnderBuyersName},
            { key: 'certifyTrueCopyOfTaxDeclarationForLandAndBuilding', type: 'file', label: "Certify True Copy Of Tax Declaration For Land And Building Under Buyer's Name", value: certifyTrueCopyOfTaxDeclarationForLandAndBuilding},
            { key: 'certifyTrueCopyOfTaxClearance', type: 'file', label: "Certify True Copy Of Tax Clearance Under Buyer's Name", value: certifyTrueCopyOfTaxClearance},
            { key: 'receiptOfUpdatedAmelyar', type: 'file', label: 'Receipt Of Updated Amelyar', value: receiptOfUpdatedAmelyar},
            { key: 'receivingCopyOfCollateralDocuments', type: 'file', label: 'Receiving Copy of Collateral Documents', value: receivingCopyOfCollateralDocuments},
        ]

        return (
            !!client ? <SaleStage 
                title="Collateral Docs"
                fields={step10Fields}
                isCompleted={isCompleted}
                completionDate={completionDate}
                client={client}
                stage="collateralDocs"
                updateClient={updateClient}
                others={others}
                previousStep={this.props.previousStep}
                nextStep={null}
            /> : null
        )
    }
}

export default Step9SS
